import TipMsgDialogComponent from "./tipMsgDialog"

const CommonComponent = {
  install: function (Vue) {
    Vue.component("TipMsgDialog", TipMsgDialogComponent)
  }
}

export default CommonComponent



// WEBPACK FOOTER //
// ./src/components/common/common.js